import Alert from './alert.vue'


function install (Vue, options = {}) {
  const property = options.property || '$alert'
  delete options.property
  const vuetify = options.vuetify
  delete options.vuetify
  const i18n = options.i18n
  delete options.i18n

  const Ctor = Vue.extend(Object.assign({ vuetify, i18n }, Alert))
  function createDialogCmp (options) {
    const container = document?.querySelector('[data-app=true]') || document.body
    return new Promise(resolve => {
      const cmp = new Ctor(Object.assign({}, {
        propsData: Object.assign({}, Vue.prototype[property].options, options),
        destroyed: () => {
          container.removeChild(cmp.$el)
          resolve()
        }
      }))
      container.appendChild(cmp.$mount().$el)
    })
  }

  function show (message, options = {}) {
    options.message = message
    return createDialogCmp(options)
  }

  Vue.prototype[property] = show
  Vue.prototype[property].options = options || {}
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}


export default install
